namespace GeniuzPOS.AdvPromo {
@Serenity.Decorators.registerClass()
export class Adv05ItemExDtEditor extends Serenity.Extensions.GridEditorBase<Adv05ItemExDtRow> {
    protected getColumnsKey() { return Adv05ItemExDt2Columns.columnsKey; }
    protected getDialogType() { return Adv05ItemExDtDialog; }
    protected getLocalTextPrefix() { return Adv05ItemExDtRow.localTextPrefix; }
    protected getService() { return Adv05ItemExDtService.baseUrl; }


    constructor(container: JQuery) {
        super(container);
    }
    protected getButtons() {
        var buttons = super.getButtons();

        // remove first button (Add button)
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
        // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

        // Add buttons import excel, pdf      
        
       
        return buttons;
    }



    protected getSlickOptions() {
        var opt = super.getSlickOptions();
        opt.showFooterRow = true;
        // opt.frozenColumn = 1;
        return opt;
    }

    protected getViewOptions() {
        var opt = super.getViewOptions();
        opt.localSort = true;
        return opt;
    }

   

    
}}